export const RATING_ITEM_COLOR = {
    empty: '#e9c7d1',
    filled: '#a02842',
} as const;

export const RATING_TYPE = {
    circle: 'circle',
    default: 'default',
} as const;

export const RATING_ITEMS_AMOUNT = 5;
